import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../lib/api';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) {
      return;
    }
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(window.location.hash.replace('#', '')).get('session_id');
    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    const exchangeSession = async () => {
      try {
        const response = await apiClient.post('/auth/session', { session_id: sessionId });
        setUser(response.data);
        navigate('/dashboard', { replace: true });
      } catch (error) {
        navigate('/login', { replace: true });
      }
    };

    exchangeSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50" data-testid="auth-callback-page">
      <div className="text-center space-y-4">
        <div className="w-12 h-12 rounded-full border-4 border-t-transparent animate-spin mx-auto" style={{ borderColor: '#53a5ca', borderTopColor: 'transparent' }} />
        <p className="text-gray-600">Finishing secure sign in…</p>
      </div>
    </div>
  );
}